import {normalize} from 'normalizr'
import Vue from 'vue'
import run_schema from '../schema/run_schema'
import api from '../../api'
import {green, orange, sort_funcs, sum_reads, yellow} from '../defaults'
import format from 'string-format'

// const SET_RUN_DATA_LIST = 'SET_RUN_DATA_LIST'
const SET_PLANNING_RUN_NAMES = 'SET_PLANNING_RUN_NAMES'
// const SET_EXPLIB_LIST = 'SET_EXPLIB_LIST'
const SET_RUNS_PAGE = 'SET_RUNS_PAGE'
// const SET_RUNS_COUNT = 'SET_RUNS_COUNT'
const SET_RUNS_PAGE_TIMESTAMP = 'SET_RUNS_PAGE_TIMESTAMP'
const SET_BARCODES_DETAILS = 'SET_BARCODES_DETAILS'
const EXPLIB_TOGGLE_CHECK = 'EXPLIB_TOGGLE_CHECK'
const SET_RUN_DATA = 'SET_RUN_DATA'
const UPDATE_EXPLIB = 'UPDATE_EXPLIB'
const UPDATE_LIB = 'UPDATE_LIB'
const ADD_PLAN = 'ADD_PLAN'
const CHECK_ALL = 'CHECK_ALL'
const UNCHECK_ALL = 'UNCHECK_ALL'
const ADD_EXPLIBS = 'ADD_EXPLIBS'
const DELETE_EXPLIBS = 'DELETE_EXPLIBS'
const SET_SHOW_ONLY_PERSONALS = 'SET_SHOW_ONLY_PERSONALS'
const CHANGE_SORT_FUNC = 'CHANGE_SORT_FUNC'
const CHANGE_NGS_APP_COLOR = 'CHANGE_NGS_APP_COLOR'
const ERASE_CACHED_PAGES = 'ERASE_CACHED_PAGES'
const ERASE_ALL_CACHED_PAGES = 'ERASE_ALL_CACHED_PAGES'

const initialState = {
	runs: {},
	exps: {},
	runs_count: 0,
	show_only_personals: false,
	barcodes_counts: {},
	explibs_checked: {},
	planning_run_names: [],
	runs_pages: {},
	planning_runs: [],
	run_id: null,
	sort_func: 'BY_POST_DATE',
	timestamp: 0

}

const getters = {

	show_only_personals: (state) => {
		return state.show_only_personals
	},

	exps: (state) => {
		if (state.run_id) {
			return state.runs[state.run_id].ngsExp_set.map((exp_id) => state.exps[exp_id])
		} else {
			return []
		}
	},

	run_explibs_checked: (state) => {
		if (state.run_id) {
			return Object.keys(state.explibs_checked[state.run_id])
		} else {
			return []
		}
	},

	pers_explibs_checked: (state, getters) => {
		return getters.run_explibs_checked.filter((explib_id) => getters.shown_explib_ids.includes(explib_id))
	},

	explibs: (state) => {
		if (state.run_id) {
			return state.runs[state.run_id].explibs
		} else {
			return {}
		}
	},

	user_explibs: (state, getters) => {
		return Object.values(getters.explibs).filter((explib) => 'amplicons_num' in explib)
	},

	user_explibs_sorted: (state, getters) => {
		if (state.sort_func === 'BY_POST_DATE') {
			return getters.user_explibs
		} else {
			return getters.user_explibs.concat().sort(sort_funcs[state.sort_func])
		}
	},

	pers_explibs: (state, getters, rootState) => {
		if (rootState.auth.user) {
			let personal_id = rootState.auth.user.personal_id
			return getters.user_explibs_sorted.filter((explib) => (explib.library.personal && explib.library.personal.id === personal_id) ||
				(explib.library.ngs_appointment.personal && explib.library.ngs_appointment.personal.id === personal_id))
		} else {
			return []
		}
	},

	shown_checked_explibs: (state, getters) => {
		if (state.show_only_personals) {
			return getters.pers_explibs_checked
		} else {
			return getters.run_explibs_checked
		}
	},

	get_explib: (state) => (explib_id) => {
		return state.runs[state.run_id].explibs[explib_id]
	},

	get_lib_name: (state, getters) => (explib_id) => {
		let lib = getters.get_explib(explib_id).library
		let name = lib.draft_name ? lib.draft_name : lib.name
		return name

	},

	shown_checked_lib_names: (state, getters) => {
		return getters.shown_checked_explibs.map(getters.get_lib_name)
	},

	shown_explibs: (state, getters) => {
		if (state.show_only_personals) {
			return getters.pers_explibs
		} else {
			return getters.user_explibs_sorted
		}

	},

	checked_reads: (state, getters) => {
		return getters.shown_explibs.filter((explib) => getters.shown_checked_explibs.includes(explib.id.toString())).reduce(sum_reads, 0).toLocaleString()
	},

	shown_explib_ids: (state, getters) => {
		return getters.shown_explibs.map((explib) => explib.id.toString())
	},

	barcodes_revision: (state, getters, rootState) => (explibs, run) => {

		let barcode_set = run.barcode_set
		let chip_num = run.chip_num
		let exps = run.ngsExp_set
		let barcodes_all = rootState.barcodes.barcodeSets[barcode_set].barcodes_dict
		let run_barcodes = {}
		for (let index in barcodes_all) {
			if (Object.prototype.hasOwnProperty.call(barcodes_all, index)) {
				run_barcodes[barcodes_all[index].barcode.name] = new Array(chip_num + 1).fill(0)
			}
		}
		for (let explib_id in explibs) {
			if (Object.prototype.hasOwnProperty.call(explibs, explib_id)) {
				let explib = explibs[explib_id]
				let barcode = explib.library.barcode
				let barcode_name = barcode.name
				if (barcode !== 'Empty') {
					try {
						run_barcodes[barcode_name][0] += 1//.push(explib.target_reads_adjust)
						run_barcodes[barcode_name][exps.indexOf(explib.experiment.id) + 1] += 1//.push(explib.target_reads_adjust)
					} catch (error) {
					}
				}
			}
		}
		run_barcodes['Empty'] = new Array(chip_num + 1).fill(0)
		return run_barcodes
	},

	planning_run_names: function (state, getters, rootState) {
		return state.planning_run_names
	}
}

const actions = {

	/**
	 * Не запрашивает справочники, только runs и missing_barcode_sets,
	 * обновляет баркодные цвета
	 *
	 * @param commit
	 * @param getters
	 * @param dispatch
	 * @param state
	 * @param run_id
	 * @returns {Promise<[any]>}
	 */

	littleFetch({commit, getters, dispatch, state}, {run_id}) {

		console.log('store.runs.littleFetch() ')

		return api.runs.getRun(run_id)
			.then(function (response) {

				const run_data = normalize(response.data, run_schema)

				// наборы баркодов (названия) из всех планируемых запусков
				const barcode_set_set = new Set([run_data.entities.run[run_data.result].barcode_set, 'EmptySet'])

				// Получим списки баркодов для используемых наборов баркодов
				const barcodes_update_promise = dispatch(
					'barcodes/get_missing_barcode_sets',
					{barcodeSet_name_set: barcode_set_set}, {root: true}) // barcodeSet_name_set - имя именованного параметра

				return Promise.all([run_data, barcodes_update_promise])
			})
			.then(function ([run_data, barcodes_update_result]) {
					let run_id = run_data.result

					commit(SET_BARCODES_DETAILS, [run_id, getters.barcodes_revision(run_data.entities.explib, run_data.entities.run[run_id])])
					commit(SET_RUN_DATA, run_data)
					// к этому моменту обработчики then() в store.barcodes.update()
					// уже выполнены и данные comit в состоянии store.state.barcodes.barcodeSets
					// barcodes_update_result - пустой, потому что store.barcodes.update() возвращает ничего
					console.log('store.runs.fetchData() then() barcodes updated')
					console.log('store.runs.fetchData() then() panels updated')
				}
			)
	},


	fetchData({commit, getters, dispatch}) {

		console.log('store.runs.fetchData() ')

		// Аутентификацию проверять не нужно
		// 1. Ее проверял router при отображении UI работы с запусками
		// 2. Сервер REST всегда проверяет наличие аутентификации при запросах.
		// 3. Если аутентификация потерялась в процессе, то нужно ли что-то предпринять?

		const panels_update_promise = dispatch('panels/update', null, {root: true})
		const all_barcode_sets_promise = dispatch('barcodes/listBarcodeSet', null, {root: true})
		const barcode_boxes_promise = dispatch('barcodes/getBarcodeBoxes', null, {root: true})
		const all_chip_types_promise = dispatch('others/listChipTypes', null, {root: true})
		const ngs_sources_promise = dispatch('others/listNgsSources', null, {root: true})
		const sample_type_promise = dispatch('others/listSampleTypes', null, {root: true})

		return Promise.all([
			panels_update_promise,
			all_barcode_sets_promise,
			barcode_boxes_promise,
			all_chip_types_promise,
			ngs_sources_promise,
			sample_type_promise
		])
			.then(function ([
        panels_update_promise,
        barcode_sets_response,
        barcode_boxes_response,
        chip_type_response,
        ngs_sources_response,
        sample_type_response
      ]) {
				console.log('store.runs.fetchData() api.runs.getPlanningRuns().then()')
				const barcode_set_set = new Set(['EmptySet'])

				// Получим пустой набор баркодов, если его нет :)
				return dispatch(
					'barcodes/get_missing_barcode_sets',
					{barcodeSet_name_set: barcode_set_set}, {root: true}) // barcodeSet_name_set - имя именованного параметра
				// return Promise.resolve()

			})
	},

	getRuns({commit, getters, dispatch}, {page, per_page, query_list, timestamp}) {
		query_list.push(format("page={0}", page))
		query_list.push(format("page_size={0}", per_page))
		query_list.push(format("timestamp={0}", timestamp))

		commit(SET_RUNS_PAGE_TIMESTAMP, timestamp)

		return api.runs.getRuns(query_list)
			.then(function (response) {
				commit(SET_RUNS_PAGE, {
					timestamp: parseInt(response.data.timestamp),
					runs: response.data.results,
					page: page,
					count: response.data.count})
				// commit(SET_RUNS_COUNT, {timestamp: response.timestamp, count: response.data.count})
			})
			.catch(function (reason) {
				if (reason.response && reason.response.status && reason.response.status !== 403) { // Если это не просто проблема с аутентификацией
					dispatch('error/error_occurred', {error: reason, ok: false}, {root: true})
				}
			})
	},

	getPlanningRunNames({commit, getters, dispatch}) {
		return api.runs.getRuns(
			["state=PLANNING"]
		).then(function (response) {
				let run_names = response.data.results
				commit(SET_PLANNING_RUN_NAMES, run_names)
			}
		).catch(function (reason) {
			if (reason.response && reason.response.status && reason.response.status !== 403) { // Если это не просто проблема с аутентификацией
				dispatch('error/error_occurred', {error: reason, ok: false}, {root: true})
			}
		})
	},

	addExplibs({commit}, {run_explibs}) {
		commit('ADD_EXPLIBS', run_explibs)
	},

	deleteExplibs({commit}, {run_explibs}) {
		commit('DELETE_EXPLIBS', run_explibs)
		commit('EXPLIB_TOGGLE_CHECK', run_explibs)
	},

	/**
	 *
	 * @param commit
	 * @param explibs = {run_id: explib_set}
	 */

	explib_toggle_check({commit}, {explibs}) {
		commit(EXPLIB_TOGGLE_CHECK, explibs)
	},

	check_all({commit}, {explibs}) {
		commit(CHECK_ALL, explibs)
	},

	create_run({dispatch}, {attrs}) {
		return api.runs.create_run(attrs)
	},

	//'runs/update_explib', {run_id: this.run_id, explib_id: explib_id, what: 'target_reads_adjust', 'data': explib_data['tra']}
	update_explib({commit}, {run_id, explib_id, what, data}) {
		commit(UPDATE_EXPLIB, {run_id: run_id, explib_id: explib_id, what: what, data: data})
	},

	update_lib({commit}, {run_id, explib_id, what, data}) {
		commit(UPDATE_LIB, {run_id: run_id, explib_id: explib_id, what: what, data: data})
	},

	//dialog.$store.dispatch('runs/addPlanningRunName', {run_name: [data.run_id, data.run_name]})
	addPlanningRunName({commit}, run_name) {
		commit(ADD_PLAN, run_name)
	},

	setShowOnlyPersonals({commit}, val) {
		commit(SET_SHOW_ONLY_PERSONALS, val)
	},

	changeSortFunc({commit}, sort_func) {
		commit(CHANGE_SORT_FUNC, sort_func['sort_func'])
	},

	setNgsAppColor({commit}, explibs_colors) {
		commit(CHANGE_NGS_APP_COLOR, explibs_colors)
	},

	eraseCachedPages({commit}, except_page) {
		if (except_page == null) {
			commit(ERASE_ALL_CACHED_PAGES)
		} else {
			commit(ERASE_CACHED_PAGES, except_page)
		}
	},

	exp_data_sync({commit}, {experiment, params}) {
		console.debug(format(
			"store.modues.runs.exp_data_sync( {params} )",
			{params: params}))

		return api.experiments.data_sync(experiment, params)
			.then(function (response) {
				return response.data
				// непонятно что здесь комитить в store в браузере
				// commit()
			})
	}
}

const mutations = {

	[ERASE_ALL_CACHED_PAGES](state) {
		Vue.set(state, 'runs_pages', {})
	},

	[ERASE_CACHED_PAGES](state, page) {
		if (page in state.runs_pages) {
			let cache = {}
			cache[page] = state.runs_pages[page]
			Vue.delete(state, 'runs_pages')
			Vue.set(state, 'runs_pages', cache)
		}
	},

	[CHANGE_NGS_APP_COLOR](state, explibs_colors) {
		let explib_ids = explibs_colors.explib_ids
		let color = explibs_colors.color
		for (let i = 0; i < explib_ids.length; i++) {
			state.runs[state.run_id].explibs[explib_ids[i]].library.ngs_appointment.back_color = color
		}
	},

	[CHANGE_SORT_FUNC](state, sort_func) {
		state.sort_func = sort_func
	},

	[SET_SHOW_ONLY_PERSONALS](state, val) {
		state.show_only_personals = val
	},

	[ADD_EXPLIBS](state, run_explibs) {
		let run = state.runs[state.run_id]
		let explibs = run.explibs
		let barcodes = state.barcodes_counts[state.run_id]
		let exps = run.ngsExp_set
		run_explibs['explibs'].map(
			function (explib) {
				let exp = explib.experiment.id
				let barcode = explib.library.barcode.name
				if (barcode !== 'Empty' && barcode in barcodes) {
					barcodes[barcode][0] += 1
					barcodes[barcode][exps.indexOf(exp) + 1] += 1
				} else {
					barcodes[barcode][0] = 1
					barcodes[barcode][exps.indexOf(exp) + 1] = 1
				}
				Vue.set(explibs, explib.id, explib)
			})
	},

	[DELETE_EXPLIBS](state, run_explib_ids) {
		let run = state.runs[state.run_id]
		let explibs = run.explibs
		let barcodes = state.barcodes_counts[state.run_id]
		let exps = run.ngsExp_set
		run_explib_ids['explibs'].map(
			function (explib_id) {
				let explib = run.explibs[explib_id]
				let exp = explib.experiment.id
				let barcode = explib.library.barcode.name
				if (barcode !== 'Empty' && barcode in barcodes) {
					barcodes[barcode][0] -= 1
					barcodes[barcode][exps.indexOf(exp) + 1] -= 1
				}
				Vue.delete(explibs, explib_id)
			})
	},

	[SET_PLANNING_RUN_NAMES](state, runs) {
		/**
		 * runs = [{id: id, name: run_name}]
		 */
		Vue.set(state, 'planning_run_names', runs)
	},

	[ADD_PLAN](state, name) {
		state.planning_run_names.push(name)
	},

	[UPDATE_EXPLIB](state, obj) {
		state.runs[obj.run_id].explibs[obj.explib_id][obj.what] = obj.data
	},

	[UPDATE_LIB](state, obj) {
		let what = obj.what
		let value = obj.data
		let run_id = obj.run_id
		let explib_id = obj.explib_id
		let run = state.runs[run_id]
		let exps = run.ngsExp_set
		let explib = run.explibs[explib_id]
		let lib = explib.library

		if (what === 'barcode') {
			let run_barcodes_counts = state.barcodes_counts[run_id]
			let old_barcode = lib.barcode.name
			if (old_barcode !== 'Empty') {
				if (old_barcode in run_barcodes_counts) {
					let old_barcode_counts = run_barcodes_counts[old_barcode]
					old_barcode_counts[0]--
					old_barcode_counts[exps.indexOf(explib.experiment.id) + 1]--
				}
			}
			if (value.name !== 'Empty') {
				if (value.name in run_barcodes_counts) {
					let new_barcode_counts = run_barcodes_counts[value.name]
					new_barcode_counts[0]++
					new_barcode_counts[exps.indexOf(explib.experiment.id) + 1]++
				}
			}
		}
		lib[what] = value
	},

	/**
	 * Закомитить данные ngs_run.
	 * @param state
	 * @param run_data
	 */
	[SET_RUN_DATA](state, run_data) {

		let run_id = run_data.result
		let entities = run_data.entities
		let run = entities.run[run_id]
		let chip_num = parseInt(run.chip_num)
		let colors = [green]
		while (--chip_num) {
			colors.push(yellow)
		}
		colors.push(orange)

		state.run_id = run_id
		if (!(run_id in state.explibs_checked)) {
			Vue.set(state.explibs_checked, run_id, {})
		}
		Vue.set(state.runs, run_id, run)
		if (entities.explib) {
			Vue.set(state.runs[run_id], 'explibs', entities.explib)
		} else {
			Vue.set(state.runs[run_id], 'explibs', {})
		}

		Vue.set(state.runs[run_id], 'colors', colors)
		if (entities.experiment) {
			Object.values(entities.experiment).map((exp) => Vue.set(state.exps, exp.id, exp))
		}
	},

	[SET_BARCODES_DETAILS](state, run_barcodes_counts) {
		Vue.set(state.barcodes_counts, run_barcodes_counts[0], run_barcodes_counts[1])
	},

	[EXPLIB_TOGGLE_CHECK](state, run_explibs) {
		let explibs_checked = state.explibs_checked[state.run_id]
		let explibs = run_explibs['explibs']
		for (let i = 0; i < explibs.length; i++) {
			if (explibs[i] in explibs_checked) {
				Vue.delete(explibs_checked, explibs[i])
			} else {
				Vue.set(explibs_checked, explibs[i], true)
			}
		}
	},

	[CHECK_ALL](state, run_explibs) {
		let explibs_checked = state.explibs_checked[state.run_id]
		let explibs = run_explibs['explibs']
		let if_check = run_explibs['if_check']
		if (if_check) {
			for (let i = 0; i < explibs.length; i++) {
				Vue.set(explibs_checked, explibs[i], true)
			}
		} else {
			for (let i = 0; i < explibs.length; i++) {
				Vue.delete(explibs_checked, explibs[i])
			}
		}
	},

	[UNCHECK_ALL](state) {
		for (var key in state.explibs_checked) {
			// skip loop if the property is from prototype
			if (!Object.prototype.hasOwnProperty.call(state.explibs_checked, key)) continue
			Vue.set(state.explibs_checked, key, {})
		}
	},

	[SET_RUNS_PAGE](state, paged_runs) {
		if (paged_runs.timestamp >= state.timestamp) {
			if (paged_runs.planning) {
				state.planning_runs = paged_runs.runs
			} else {
				Vue.set(state.runs_pages, paged_runs.page, paged_runs.runs)
			}
			state.runs_count = paged_runs.count
		}
	},

	[SET_RUNS_PAGE_TIMESTAMP](state, timestamp) {
		if (state.timestamp < timestamp) {
			state.timestamp = timestamp
		}
	},

	// [SET_RUNS_COUNT](state, count) {
	// 	state.runs_count = count
	// }
}


export default {
	namespaced: true,
	state: initialState,
	actions,
	mutations,
	getters
}